import _ from 'lodash';
import { MutationTree } from 'vuex';
import { FiltersSimulationAnalysis, FiltersSimulationAnalysisState } from '@/models/states/filters-state.model';

export const mutations: MutationTree<FiltersSimulationAnalysisState> = {
  onUpdateFilters(state, payload: FiltersSimulationAnalysis) {
    state.filters = _.extend({}, state.filters, payload);
  },
};
